import { PresentationMode } from '../../../../../../../../Enums/PresentationMode';
import { ServiceClient } from '../../../../../../../../Services/ServiceClient';
import { teamPageReducerTypes } from '../../../../../../Reducer';
import {
  changeAddressForAgent,
  inheritAddressFromTeam,
} from '../../../CommonFunctions';
import { addressReducerTypes } from '../../../Reducer';

export const handleClick = (
  agentCode,
  codePrefix,
  addressState,
  addressDispatch,
  setModalMode,
  isModalOpenedOnTeamLevel,
  teamPageDispatch
) => {
  if (isModalOpenedOnTeamLevel) {
    changeAddressForTeam(
      codePrefix,
      addressState.address,
      addressDispatch,
      teamPageDispatch
    );
    return;
  }

  if (addressState.uneditedData.isInherited) {
    changeAgentAddress(
      agentCode,
      codePrefix,
      addressState.address.id,
      addressState.teamAddress.id,
      addressDispatch,
      setModalMode,
      teamPageDispatch
    );
  } else {
    if (addressState.isInherited) {
      inheritAddressFromTeam(
        agentCode,
        codePrefix,
        addressDispatch,
        teamPageDispatch
      );
    } else {
      changeAgentAddress(
        agentCode,
        codePrefix,
        addressState.address.id,
        addressState.teamAddress.id,
        addressDispatch,
        setModalMode,
        teamPageDispatch
      );
    }
  }
};

const changeAddressForTeam = (
  codePrefix,
  address,
  addressDispatch,
  teamPageDispatch
) => {
  ServiceClient.setAddressForTeam(codePrefix, address.id, () => {
    ServiceClient.getAddressListForTeam(codePrefix, list => {
      addressDispatch({
        type: addressReducerTypes.setSelectedAddress,
        list,
      });
      teamPageDispatch({
        type: teamPageReducerTypes.updateAddressInfo,
        isModalOpenedOnTeamLevel: true,
        address,
      });
    });
  });
};

const changeAgentAddress = (
  agentCode,
  codePrefix,
  addressId,
  teamAddressId,
  addressDispatch,
  setModalMode,
  teamPageDispatch
) => {
  if (addressId === teamAddressId) {
    setModalMode(PresentationMode.Warning);
  } else {
    changeAddressForAgent(
      agentCode,
      codePrefix,
      addressId,
      addressDispatch,
      teamPageDispatch
    );
  }
};
